import SessionItem from '~/components/Session/Session'
import ShiftMinimal from '~/panels/components/Shift/ShiftMinimal'
import appointmentIsShift from '~/panels/utils/appointmentIsShift.utils'
import { Appointment, SessionStatus } from '~/types/tutoring-api'

export default function AppointmentItem({
  appointment,
  isTutor,
  setSessionStatus,
}: {
  appointment: Appointment
  isTutor: boolean
  setSessionStatus: (sessionId: number, status: SessionStatus) => void
}): React.ReactElement {
  if (appointmentIsShift(appointment)) {
    return <ShiftMinimal endTime={appointment.endTime} key={appointment.startTime} startTime={appointment.startTime} />
  }

  return (
    <SessionItem
      isTutor={isTutor}
      key={appointment.id}
      session={appointment}
      sessionStudent={appointment.student}
      sessionTutor={appointment.mentor}
      setSessionStatus={setSessionStatus}
    />
  )
}
